module.exports = __webpack_public_path__ + "static/5-large-a93e8017580500310cb1ca42eaafa2ab.jpg";